module.exports = __webpack_public_path__ + "img/professionals.1d68cbb2.png";